export const startLauncherPortalId = 'start-launcher-portal'
